module.exports = __webpack_public_path__ + "assets/favicon.ico";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/favicon.ico
 ** module id = 216
 ** module chunks = 1
 **/